import ListItem, { ListItemProps } from "@mui/material/ListItem";
import { styled, Theme } from "@mui/material/styles";
import { CSSProperties } from "@mui/material/styles/createTypography";
import React, { FunctionComponent } from "react";
import { itemListStyle } from "designSystem/styles/style-functions";

const PREFIX = "SelectListItem";

const classes = {
	root: `${PREFIX}root`,
	defaultHeight: `${PREFIX}defaultHeight`,
	hspacing1: `${PREFIX}hspacing1`,
	hspacing2: `${PREFIX}hspacing2`,
	hspacing3: `${PREFIX}hspacing3`,
	hspacing4: `${PREFIX}hspacing4`,
	vspacing1: `${PREFIX}vspacing1`,
	vspacing2: `${PREFIX}vspacing2`,
	vspacing3: `${PREFIX}vspacing3`,
	vspacing4: `${PREFIX}vspacing4`,
};

const StyledListItem = styled(ListItem)(({
	theme,
}) => ({
	[`&.${classes.root}`]: itemListStyle(theme),

	[`&.${classes.defaultHeight}`]: {
		height: DEFAULT_HEIGHT,
	},

	[`&.${classes.hspacing1}`]: hspacing(theme, 1),
	[`&.${classes.hspacing2}`]: hspacing(theme, 2),
	[`&.${classes.hspacing3}`]: hspacing(theme, 3),
	[`&.${classes.hspacing4}`]: hspacing(theme, 4),
	[`&.${classes.vspacing1}`]: vspacing(theme, 1),
	[`&.${classes.vspacing2}`]: vspacing(theme, 2),
	[`&.${classes.vspacing3}`]: vspacing(theme, 3),
	[`&.${classes.vspacing4}`]: vspacing(theme, 4),
}));

const DEFAULT_HEIGHT = 26;

const hspacing = ({ spacing }: Theme, n: number): CSSProperties => ({
	paddingLeft: spacing(n),
	paddingRight: spacing(n),
});

const vspacing = ({ spacing }: Theme, n: number): CSSProperties => ({
	paddingBottom: spacing(n),
	paddingTop: spacing(n),
});

export interface SelectListItemProps extends ListItemProps<"li"> {
	/** indicates height of item (default 26) */
	height?: number;

	/** horizontal spacing (padding) to use for each item (default 2) */
	hspacing?:
	| 0
	| 1
	| 2
	| 3
	| 4;

	/** vertical spacing (padding) to use for each item (default 0) */
	vspacing?:
	| 0
	| 1
	| 2
	| 3
	| 4;
}

const SelectListItem: FunctionComponent<SelectListItemProps> = (props) => {
	const {
		className,
		height,
		hspacing,
		vspacing,
		...otherProps
	} = props;


	const h = height || DEFAULT_HEIGHT;
	const isDefault = (h === DEFAULT_HEIGHT);
	const heightCss = isDefault ? classes.defaultHeight : "";
	const hCss = classes[`hspacing${hspacing || 2}`];
	const vCss = classes[`vspacing${vspacing || 0}`];

	return (
		<StyledListItem
			className={`${className || ""} ${classes.root} ${heightCss} ${hCss} ${vCss}`}
			disableGutters
			style={isDefault ? null : { height: h }}
			{...otherProps}
		/>
	);
};

export default SelectListItem;
